import { Component, OnInit, Output, ViewChild, OnDestroy } from '@angular/core';
import { ToolDescriptionService, ToolService, ToolTypeService, ToolNumberService } from '../../../camtl.service';
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { Tool } from '../../../../../shared/model';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { SystemSelectService } from '../../../system-select/system-select.service';
import { CgpSnackbarService } from '../../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { CgpAlertDialogService } from '../../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { ToolHandednessService } from '../../../../mesc/mesc.service';
import { CgpGridComponent } from '../../../../../shared/cgp-grid/cgp-grid.component';
import { MasterToolListBase } from '../../master-tool-list-base.component';
import { Subscription } from 'rxjs/Subscription';
import { RouteValidationService } from "../../../../../shared/route-validation.service";
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-build-tools',
  templateUrl: './build-tools.component.html',
  // styleUrls: ['./build-tools.component.scss']
})
export class BuildToolsComponent extends MasterToolListBase implements OnInit, OnDestroy {

  constructor(
    toolTypeService: ToolTypeService,
    public service: ToolService,
    public toolDescriptionService: ToolDescriptionService,
    private toolNumberService: ToolNumberService,
    private systemSelectService: SystemSelectService,
    private formBuilder: FormBuilder,
    private cgpSnackbarService: CgpSnackbarService,
    private cgpAlertDialogService: CgpAlertDialogService,
    private toolHandednessService: ToolHandednessService,
    public routeValidationService: RouteValidationService) {
    super(toolTypeService, "Tool", toolDescriptionService);

  }

  editForm: FormGroup;
  isNew: boolean = false;
  editDataItem: Tool;
  showBlock: boolean = false;
  disableActions: boolean = false;

  @ViewChild(CgpGridComponent, { static: true }) grid: CgpGridComponent;


  private ngUnsubscribe: Subject<void> = new Subject<void>();

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  columns: any[] = [{
    field: 'ToolDetail.ToolNumber',
    title: 'Tool Number',
    width: 175
  },
  {
    field: 'ToolDescription',
    title: 'Description'
  },
  {
    field: 'AdditionalInfo',
    title: 'Additional Info'
  },
  {
    field: 'ToolHandedness',
    title: 'Design Handedness'
  },
  {
    field: 'LeftCount',
    title: 'LH',
    width: 70
  },
  {
    field: 'RightCount',
    title: 'RH',
    width: 70
  },
  {
    field: 'SingleCount',
    title: 'S',
    width: 70
  },
  {
    field: "MakeFurnish",
    title: "M/F",
    width: 70
  }];

  moveToFurnished = (e, dataItem, service: ToolService, system, callbackInputs) => {
    dataItem.AssignJobNumber = true;
    dataItem.AssignLocationNumber = true;
    dataItem.AssignToolNumber = true;
    dataItem.MakeFurnish = "F";
    dataItem.IsActive = true;
    dataItem.ToolTypeId = this.furnishedId;
    service.save(dataItem, false, "", true, false)
      .then((response) => {
        this.service.loading.next(false);
        this.getToolDescriptions("Tool");
        this.grid.refresh(true);
        this.cgpSnackbarService.showSnackbar({
          message: 'Tool has been moved',
          duration: 2000
        });
      })
      .catch(e => this.handleError(e._body.replace(/"/g, '')));
  }

  customButtons = [
    {
      id: "toggleToFurnished",
      class: "fa fa-share",
      callback: this.moveToFurnished,
      title: 'Move to Furnished'
    }
  ];

  isDisabled = (id) => {
    switch (id) {
      case "blockToolNumbersBuild":
        return this.disableActions;
      case "add":
        if (!this.buildToolId) {
          return true;
        }
        else {
          return false;
        }
      default:
        return false;
    }
  }

  showBlockWindow = (e, service, system, callbackInputs) => {
    this.showBlock = true;
  }

  customToolbarButtons = [
    {
      id: "blockToolNumbersBuild",
      iconClass: "fa fa-lock",
      title: "Block Tool Numbers",
      text: "Block Tool Numbers",
      callback: this.showBlockWindow,
      callbackInputs: this.showBlock
    }
  ];

  onRead = (): Promise<any> => {
    if (this.system && this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Configuration/BuildTools')) {
      return this.toolTypeService.read()
        .then((response: any) => {
          this.buildToolId = response.filter((item) => {
            return item.Description.toUpperCase() === "TOOL";
          })[0].Id;

          this.furnishedId = response.filter((item) => {
            return item.Description.toUpperCase() === "FURNISHED EQUIPMENT";
          })[0].Id;

          return this.toolDescriptionService.read("?$filter=IsActive eq true and ToolTypeId eq " + this.buildToolId, false).then(() => {
            return this.service.read('/' + this.system.Id + "/toolType/" + this.buildToolId, true)
              .then((response) => {
                for (var i = 0; i < response.length; i++) {
                  response[i]["DisplayNumber"] = response[i].ToolDetail.ToolNumber;
                }
                this.toolDescriptionService.loading.next(false);
                return response;
              });
          });
        })
    }
  }

  disableToolbar = (controlName: string) => {
    let isDisabled: boolean = false;
    if (!this.buildToolId && controlName === "add") {
      isDisabled = true;
    }
    return isDisabled;
  }

  onToolSave = (dataItem, isNew) => {
    this.service.save(dataItem, isNew, "", true, false)
      .then(() => {
        this.service.loading.next(false);
        this.grid.refresh(true);
        this.cgpSnackbarService.showSnackbar({
          message: isNew ? "Record has been created" : "Record has been updated",
          duration: 2000
        });
        this.toolNumberService.read("/" + this.system.Id + "/blockedtoolnumbers", true)
          .then(data => {
            if (data && data[0] && typeof data[0] === 'string')
              this.toolNumberService.next(data.map(x => <any>{ value: x }))
          });

      })
      .catch((response) => this.handleError(response._body.replace(/"/g, '').replace(/Value cannot be null\.\\r\\nParameter name: /g, '')));
  }


  handleDelete = (dataItem): Promise<any> => {
    return this.service.remove('/' + dataItem.Id);
  }

  handleHandednessChange = (toolHandednessId: string = "") => {
    var handednessName = "";

    let handedness = this.toolHandednessService.data.find(
      handedness => toolHandednessId === handedness.Id
    )

    if (handedness) {
      handednessName = handedness.Name
    }
    this.editForm.removeControl("LeftCount");
    this.editForm.removeControl("RightCount");
    this.editForm.removeControl("SingleCount");

    if (handednessName === "S") {
      this.editForm.addControl("SingleCount", new FormControl(0, Validators.required));
    }
    else if (handednessName === "L" || handednessName === "R") {
      this.editForm.addControl("LeftCount", new FormControl(0, Validators.required))
      this.editForm.addControl("RightCount", new FormControl(0, Validators.required));
    } else {
      this.editForm.addControl("LeftCount", new FormControl(0, Validators.required))
      this.editForm.addControl("RightCount", new FormControl(0, Validators.required));
      this.editForm.addControl("SingleCount", new FormControl(0, Validators.required));
    }
  }

  onEdit = (dataItem) => {
    this.handleHandednessChange(dataItem.ToolHandednessId);
  }


  template = {
    controls: {
      add: true,
      edit: true,
      delete: true,
      excel: true,
      customToolbar: this.customToolbarButtons,
      isDisabled: this.isDisabled
    },
    read: this.onRead,
    save: this.onToolSave,
    delete: this.handleDelete,
    columns: this.columns,
    service: this.service,
    edit: this.onEdit,
    displayField: "DisplayNumber",
    fileName: 'build_tools.xlsx'
  };

  ngOnInit() {
    this.editForm = this.formBuilder.group({
      Id: [],
      ToolNumber: [{ value: [] }],
      ToolDescriptionId: [{ value: [] }, Validators.required],
      ToolDescription: [""],
      AdditionalInfo: [""],
      ToolHandednessId: ["", Validators.required],
      DesignHandedness: [{ value: [] }],
      LeftCount: [0, Validators.compose([Validators.required, Validators.min(0)])],
      RightCount: [0, Validators.compose([Validators.required, Validators.min(0)])],
      SingleCount: [0, Validators.compose([Validators.required, Validators.min(0)])],
      CreatedBy: [],
      CreatedDate: [],
      SystemId: [""],
      MakeFurnish: [""],
      ToolTypeId: [""],
      JobNumber: [],
      ToolTypeName: [""],
    })

    this.systemSelectService.system$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(system => {
        this.system = system;
        this.editDataItem = undefined;
        if (this.system && this.routeValidationService.isActiveRoute('MESC/CAMTL/MasterToolList/Configuration/BuildTools')) {
          this.toolHandednessService.query();
          this.toolNumberService.read("/" + this.system.Id + "/blockedtoolnumbers", true)
            .then(data => {

              data = data.sort((a, b) => {
                let check1: string = a.toUpperCase();
                let check2: string = b.toUpperCase();
                if (check1 < check2) return 1;
                if (check1 > check2) return -1;
                return 0;
              });

              if (data && data[0] && typeof data[0] === 'string')
                this.toolNumberService.next(data.map(x => <any>{ value: x }))
            });
          if (this.system.AllocationStatus !== null && this.system.AllocationStatus.toLowerCase().indexOf("process") !== -1) {
            this.disableActions = true;
            this.template.controls.add = false;
            this.template.controls.edit = false;
            this.template.controls.delete = false;
          }
          else {
            this.disableActions = false;
            this.template.controls.add = true;
            this.template.controls.edit = true;
            this.template.controls.delete = true;
          }
        }
      });

    this.systemSelectService.get();
    this.moveToFurnished.bind(this);
  }

  private compare(a, b): number {
    try {
      let check1: string = a.toLowerCase(), check2 = b.toLowerCase();
      return check2 > check1 ? 1 : check2 < check1 ? -1 : 0;
    } catch (e) {
      return 0;
    }
  }


  closeForm() {
    this.showBlock = false;
    this.service.loading.next(false);
  }

  onCancel(e) {
    e.preventDefault();
    this.closeForm();
  }

  disableBlock(form) {
    if (!parseInt(form.lastElementChild.value) || parseInt(form.lastElementChild.value) < 1) {
      return true;
    }
    return false;
  }

  onSave = (e, blockToolQuantity, form) => {
    e.preventDefault();
    this.service.blockToolNumbers(this.system.Id, blockToolQuantity)
      .then(() => {
        this.service.loading.next(false);
        this.showBlock = false;
        this.cgpSnackbarService.showSnackbar({
          message: blockToolQuantity == 1 ? '1 tool number was generated' : blockToolQuantity + ' tool numbers were generated',
          duration: 2000
        });
        this.toolNumberService.getBlockedToolNumbersForSystem(this.system.Id)
          .then(data => {
            data = data.sort((a, b) => {
              let check1: string = a.toUpperCase();
              let check2: string = b.toUpperCase();
              if (check1 < check2) return 1;
              if (check1 > check2) return -1;
              return 0;
            });

            if (data && data[0] && typeof data[0] === 'string')
              this.toolNumberService.next(data.map(x => <any>{ value: x }))
          });
        this.service.loading.next(false);
      })
  }



  toolNumberControl = {
    type: 'combobox',
    name: 'ToolNumber',
    title: 'Tool Number',
    placeholder: 'Select Tool Number',
    service: this.toolNumberService,
    textField: "value",
    valueField: "value",
    sync: true
  }

  formDialog = {
    title: "Build Tool",
    formControls: [
      this.toolNumberControl,
      {
        type: 'combobox',
        name: "ToolDescriptionId",
        title: "Tool Description",
        placeholder: 'Select Tool Description',
        textField: "Name",
        valueField: "Id",
        service: this.toolDescriptionService
      },
      {
        type: 'text',
        name: 'AdditionalInfo',
        title: 'Additional Info'
      },
      {
        type: 'combobox',
        name: 'ToolHandednessId',
        title: 'Design Handedness',
        onChange: this.handleHandednessChange,
        textField: 'Name',
        valueField: 'Id',
        placeholder: 'Select Design Handedness...',
        service: this.toolHandednessService
      },
      {
        type: 'number',
        name: 'LeftCount',
        title: 'LH',
        minimum: 0,
        step: 1
      },
      {
        type: 'number',
        name: 'RightCount',
        title: 'RH',
        minimum: 0,
        step: 1
      },
      {
        type: 'number',
        name: 'SingleCount',
        title: 'S',
        minimum: 0,
        step: 1
      },
      {
        type: 'presetCombobox',
        name: 'MakeFurnish',
        title: 'M/F',
        placeholder: 'M/F',
        textField: 'value',
        valueField: 'value',
        data: [
          { "value": "M" },
          { "value": "F" }
        ]
      }
    ]
  }

  setModelHandler() {
    this.editDataItem = new Tool();
    this.editDataItem.ToolTypeId = this.buildToolId;
    this.editDataItem.MakeFurnish = "M";
    this.editDataItem.LeftCount = 0;
    this.editDataItem.RightCount = 0;
    this.editDataItem.SingleCount = 0;
    this.editForm.addControl("LeftCount", new FormControl(0, Validators.required));
    this.editForm.addControl("RightCount", new FormControl(0, Validators.required));
    this.editForm.addControl("SingleCount", new FormControl(0, Validators.required));
    this.editDataItem.JobNumber = 0;

    if (this.system) {
      this.editDataItem.SystemId = this.system.Id;
    }
  }


  handleError = (message) => {
    this.service.loading.next(false);
    this.cgpAlertDialogService.showAlertDialog({
      title: 'Error',
      message: message,
      alert: 'danger',
      closeLabel: 'Close',
    })

  }

}
